import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    label: string;
    value: ReactNode;
    /** Renders the leading dot used by the company address and location rows. */
    bulleted?: boolean;
};

/** A read-only `Label: value` pair of the account and company info sections. */
function InfoField({ label, value, bulleted }: Props) {
    return (
        <span className={styles.property} data-bulleted={bulleted}>
            {label}: <b>{value}</b>
        </span>
    );
};

export default InfoField;
